import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material';
import React from 'react'
import TableActions from 'src/pages/SuminsuredComponents/TableActions';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SyncProblemIcon from '@mui/icons-material/SyncProblem';
import FunctionsIcon from '@mui/icons-material/Functions';
import request from '../../../utils/request';
import PolicyCompareQcRemarks from 'src/pages/policies/PolicyCompareQcRemarks';

function SumInsuredLabelvaluepair({ sumInsuredData, rfqId, type = null, policyDetail = null, qcRemarkOfEachSections = null, checkAllModuleIsVerified = null, setQcRemarkOfEachSections = null, EndorsementCompareQcRemarks = null }) {
  const QcRemarksComponent = EndorsementCompareQcRemarks || PolicyCompareQcRemarks;
  const [labelValuePairDatas, setLabelValuePairDatas] = React.useState(
    Object.entries(sumInsuredData?.rfqLabelValuePairList).map(value => ({
      description: value['description'],
      sumInsured: null,
      id: null,
      savedStatus: false,
      isSuminsured: value['isSuminsured']
    }))
  );

  React.useEffect(() => {
    if (rfqId) {
      getSavedLabelValueDatas(rfqId);
    }

  }, [rfqId]);

  const getSavedLabelValueDatas = async (rfq_id) => {

    request({
      url: 'rfqOffers/getRFQlabelValuePairListForOffers',
      method: 'post',
      data: {
        orderColumn: 'id',
        orderDirection: 'ASC',
        rfqId: rfq_id,
        rfqSectionId: sumInsuredData?.id
      }
    }).then(
      (response: any) => {
        if (response.data.length !== 0) {
          let result = response.data.map((labelValueData) => {
            return {
              description: labelValueData?.description,
              sumInsured: labelValueData?.sumInsured,
              id: labelValueData?.id,
              savedStatus: true,
              isSuminsured: labelValueData?.isSuminsured
            };
          });
          setLabelValuePairDatas(result);

          document.getElementById('sumInsuredBox').style.display = 'block';
        }

      },
      (error) => {
        console.log(error);

      }
    );
  };
  return (
    <TableContainer
      component={Paper}
      sx={{ maxHeight: '500px', overflowY: 'auto', mt: 1, boxShadow: 'unset' }}
    >
      <Table size="small" aria-label="a dense table">
        {sumInsuredData?.sectionName && <TableRow>
          <TableCell className='heading' colSpan={2} style={{ fontWeight: 'bold', textAlign: 'center', background: 'rgb(9 84 174)', color: '#fff', paddingTop: '2px', paddingBottom: '2px' }}>{sumInsuredData?.sectionName}</TableCell>
        </TableRow>}
        {/* <TableHead style={{ paddingTop: '0!important', paddingBottom: '0!important' }}> */}

          <TableRow style={{
            opacity:
              (
                policyDetail?.parentqcData ||
                policyDetail?.insurancePolicy?.qcData
              )?.sum_insured_sections?.[sumInsuredData?.id]?.status === 'approve'
                ? 0.5
                : 1,
            pointerEvents:
              (
                policyDetail?.parentqcData ||
                policyDetail?.insurancePolicy?.qcData
              )?.sum_insured_sections?.[sumInsuredData?.id]?.status === 'approve'
                ? 'none'
                : 'auto',
            margin: '10px 0',
            paddingTop: '0!important', paddingBottom: '0!important'
          }}>
            {/* <TableCell></TableCell> */}
            <TableCell style={{ width: '36.3vw' }}>{sumInsuredData?.sumInsuredHeaderSorted?.labelText}</TableCell>
            <TableCell style={{ paddingLeft: '2px' }}>{sumInsuredData?.sumInsuredHeaderSorted?.ValueText}</TableCell>
          </TableRow>
        {/* </TableHead> */}
        <TableBody style={{
          opacity:
            (
              policyDetail?.parentqcData ||
              policyDetail?.insurancePolicy?.qcData
            )?.sum_insured_sections?.[sumInsuredData?.id]?.status === 'approve'
              ? 0.5
              : 1,
          pointerEvents: (
            policyDetail?.parentqcData ||
            policyDetail?.insurancePolicy?.qcData
          )?.sum_insured_sections?.[sumInsuredData?.id]?.status === 'approve'
            ? 'none'
            : 'auto',
          margin: '10px 0'
        }}>
          {sumInsuredData && labelValuePairDatas?.map((labelValue, rowIndex) => (
            <TableRow
              key={rowIndex}
              sx={{
                '&:last-child td, &:last-child th': {
                  border: 0
                }
              }}
            >
              {/* <TableCell>
                                {labelValue.savedStatus ? (
                                    <CheckCircleIcon color="success" />
                                ) : (
                                    <SyncProblemIcon color="error" />
                                )}
                            </TableCell> */}
              <TableCell component="th" scope="row" style={{ width: '36.3vw' }}>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  {/* <div style={{ minWidth: '20px' }}>
                    {labelValue?.isSuminsured ? (
                      <FunctionsIcon color="primary" />
                    ) : ''}
                  </div> */}
                  <div style={{ display: 'flex', alignItems: 'center' }}> {labelValue?.description || '------------------------'}</div>
                </div>
              </TableCell>
              <TableCell style={{ paddingLeft: '2px' }}>
                {labelValue?.sumInsured}
              </TableCell>
            </TableRow>
          ))}

          <TableRow
            key={'total'}
            sx={{
              '&:last-child td, &:last-child th': {
                border: 0
              }
            }}
          >
            <TableCell component="th" scope="row" style={{ width: '36.3vw', paddingLeft: '18px' }}>
              <Typography variant="h5" >
                {sumInsuredData?.sumInsuredColumn}
              </Typography>

            </TableCell>
            <TableCell style={{ paddingLeft: '2px' }} component="th" scope="row" >
              <Typography variant="h5">
                {new Intl.NumberFormat('en-IN', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(Number(sumInsuredData?.totalSumInsured ?? 0))}
              </Typography>

            </TableCell>

          </TableRow>
          <TableRow>
            <TableCell colSpan={2}>
              {type == 'qc' && labelValuePairDatas?.length > 0 && <div style={{ marginBottom: '10px' }}>
                <QcRemarksComponent
                  modouleDetail={policyDetail}
                  qcRemarkOfEachSections={qcRemarkOfEachSections}
                  section_key={'sum_insured_sections'}
                  block_key={sumInsuredData?.id}
                  checkAllModuleIsVerified={
                    checkAllModuleIsVerified
                  }
                  setQcRemarkOfEachSections={setQcRemarkOfEachSections}
                  sectionName={sumInsuredData?.sectionName ?? ''}
                />
              </div>}
            </TableCell>
          </TableRow>

        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default SumInsuredLabelvaluepair